// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__MNWFf","horizontalContainer":"gantt_horizontalContainer__EuYo8","wrapper":"gantt_wrapper__y8ml+"};